import Drawer from './Drawer'

export default class DrawerManager {
	drawers = []
	overlay = undefined
    accountIcon = undefined
    inactive = true;

	constructor() {
		// Get all drawers from the DOM
		const drawers = Array.from(document.querySelectorAll('[data-drawer-name]'))

		// Set icon
		const icon = document.querySelector('#account-chevron')

        if (icon) this.accountIcon = icon;

		// Get drawer overlay from the DOM
		const overlay = document.querySelector('[data-drawer-overlay]')

		// Add them to DrawerManager class instance
		drawers.forEach(drawer => {
			this.drawers.push(
				new Drawer({
					name: drawer.dataset.drawerName,
					ref: drawer,
					animations: {
						in: drawer.dataset.animateIn,
						out: drawer.dataset.animateOut,
					},
					handleTrigger: this.handleTrigger.bind(this),
				}),
			)
		})

		if (overlay) {
			this.overlay = overlay

			this.overlay.addEventListener('click', () => {
				this.closeAll()
			})
		}
	}

	close = name => {
		this.drawers.find(d => d._name === name).close()
	}

    open = name => {
        this.inactive = false;

		if (this.overlay?.classList.contains('hidden')) {
			this.overlay?.classList.remove('hidden')
        }
        
        if (this.overlay.classList.contains('fade-out')) {
            this.overlay.classList.toggle('fade-out', false);
        }

		if (!this.overlay?.classList.contains('fade-in')) {
			this.overlay?.classList.add('fade-in', true)
		}

        const drawerToOpen = this.drawers.find(d => d._name === name)
        drawerToOpen.open();

        if (drawerToOpen._name !== 'menu') {
            setTimeout(() => {
                const renderedDrawerHeight = drawerToOpen._ref.clientHeight;

                if (renderedDrawerHeight % 2 !== 0) {
                    const newHeight = renderedDrawerHeight + 1;

                    drawerToOpen._ref.style.height = `${newHeight}px`;
                }
            }, 280)
        }
	}

	closeAllExcept = name => {
		this.drawers.filter(d => d._name !== name).map(d => d.close())
    }
    
    closeAccessories = () => {
        const accessoriesDrawer = document.querySelector('.accessories-drawer');

        if (accessoriesDrawer) {
            accessoriesDrawer.classList.toggle('fade-in-right', false);
            accessoriesDrawer.classList.toggle('fade-out-right', true);
        }
    }

    closeAll = () => {
		this.overlay.classList.remove('fade-in')
        this.overlay.classList.add('fade-out')
        
        if (this.accountIcon && this.accountIcon instanceof HTMLElement) {
            this.accountIcon.style.transform = 'rotateZ(0deg)'
        }

        this.drawers.map(d => d.close())
        this.closeAccessories();
        this.inactive = true;
    }
    
	addDrawer({ name, ref, animations }) {
		this.drawers.push(
			new Drawer({
				name,
				ref,
				animations: {
					in: animations.in,
					out: animations.out,
				},
				toggleOverlay: this.toggleOverlay,
				closeAllExcept: this.closeAllExcept,
				closeAll: this.closeAll,
			}),
		)
	}

	toggleOverlay(forced = false) {
		if (this.drawers.some(x => x._visible === true || forced)) {
			this.overlay.classList.toggle('hidden', false)
			this.overlay.classList.toggle('fade-in', true)
			this.overlay.classList.toggle('fade-out', false)
		} else {
			this.overlay.classList.toggle('fade-out', true)
            this.overlay.classList.toggle('fade-in', false)
		}
	}

	removeDrawer(name) {
		const found = this.drawers.findIndex(d => d.name == name)

		delete this.drawers[found]
	}

    handleTrigger({ name, visible }) {
        if (this.accountIcon && this.accountIcon instanceof HTMLElement) {
            if (name === 'account') {
                this.accountIcon.style.transform = visible ? 'rotateZ(180deg)' : 'rotateZ(0deg)'
            } else {
                this.accountIcon.style.transform = 'rotateZ(0deg)'
            }
        }

        // Close all or all except one?
        !visible ? this.closeAll() : this.closeAllExcept(name)
        
        // Always toggle overlay
		this.toggleOverlay()
	}
}
